import React, { Fragment } from "react"
import styles from "./styles.css"

const TrafficPreControleSkeleton = () => {
  return (
    <Fragment>
      <div className={`${styles.skeletonTitle} ${styles.skeleton}`}></div>
      <div className={styles.sectionSkeleton}>
        <div className={styles.cardSkeleton}>
          <div className={`${styles.skeletonText} ${styles.skeleton}`}></div>
          <div className={`${styles.skeletonText} ${styles.skeleton}`}></div>
          <div className={`${styles.skeletonText} ${styles.skeleton}`}></div>
        </div>
        <div className={styles.cardSkeleton}>
          <div
            className={`${styles.skeletonText} ${styles.skeletonGreen}`}
          ></div>
          <div
            className={`${styles.skeletonText} ${styles.skeletonGreen}`}
          ></div>
          <div
            className={`${styles.skeletonText} ${styles.skeletonGreen}`}
          ></div>
        </div>
        <div className={styles.cardSkeleton}>
          <div className={`${styles.skeletonText} ${styles.skeleton}`}></div>
          <div className={`${styles.skeletonText} ${styles.skeleton}`}></div>
          <div className={`${styles.skeletonText} ${styles.skeleton}`}></div>
        </div>
      </div>
    </Fragment>
  )
}

export default TrafficPreControleSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/TrafficPreControleSkeleton/index.js